import { useIntl } from 'react-intl';
import { HeadCell } from 'components/list/list';

const PAGE_NAME_ID = 'siteSettings.listSites';

export const useSiteSettingsColumns = () => {
  const intl = useIntl();

  const inactiveSitesColumns: HeadCell[] = [
    {
      id: 'name',
      label: intl.formatMessage({ id: `${PAGE_NAME_ID}.list.site` }),
    },
    {
      id: 'siteErpId',
      label: intl.formatMessage({ id: `${PAGE_NAME_ID}.list.siteErpIdLabel` }),
      align: 'center',
    },
    {
      id: 'hasAutomaticOrderingEnabled',
      label: intl.formatMessage({ id: `${PAGE_NAME_ID}.list.automaticOrderingLabel` }),
      align: 'center',
    },
    {
      id: 'isAscCertified',
      label: intl.formatMessage({ id: `${PAGE_NAME_ID}.list.ascLabel` }),
      align: 'center',
    },
    { id: 'actions', label: '', align: 'left', autoWidth: true },
  ];

  const activeSitesColumns: HeadCell[] = [
    { id: 'name', label: intl.formatMessage({ id: `${PAGE_NAME_ID}.list.site` }) },
    {
      id: 'siteErpId',
      label: intl.formatMessage({ id: `${PAGE_NAME_ID}.list.siteErpIdLabel` }),
      align: 'center',
    },
    {
      id: 'hasOfdEnabled',
      label: intl.formatMessage({ id: `${PAGE_NAME_ID}.list.ofdEnabledLabel` }),
      align: 'center',
    },
    {
      id: 'hasAutomaticOrderingEnabled',
      label: intl.formatMessage({ id: `${PAGE_NAME_ID}.list.automaticOrderingLabel` }),
      align: 'center',
    },
    {
      id: 'isAscCertified',
      label: intl.formatMessage({ id: `${PAGE_NAME_ID}.list.ascLabel` }),
      align: 'center',
    },
    { id: 'actions', label: '', align: 'left', autoWidth: true },
  ];

  const sitesWithoutMapping: HeadCell[] = [
    {
      id: 'name',
      label: intl.formatMessage({ id: `${PAGE_NAME_ID}.list.site` }),
    },
    {
      id: 'siteErpId',
      label: intl.formatMessage({ id: `${PAGE_NAME_ID}.list.siteErpIdLabel` }),
      align: 'center',
    },
    {
      id: 'hasAutomaticOrderingEnabled',
      label: intl.formatMessage({ id: `${PAGE_NAME_ID}.list.automaticOrderingLabel` }),
      align: 'center',
    },
    {
      id: 'isAscCertified',
      label: intl.formatMessage({ id: `${PAGE_NAME_ID}.list.ascLabel` }),
      align: 'center',
    },
    { id: 'actions', label: '', align: 'left', autoWidth: true },
  ];

  return { activeSitesColumns, inactiveSitesColumns, sitesWithoutMapping };
};
